export default __webpack_public_path__ + "static/media/quote-icon.045687dc.svg";